import mutations from "./noa-portal-mutations";
import actions from "./noa-portal-actions";
import getters from "./noa-portal-getters";
import state from "./noa-portal-state";
const store = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
export default store;